import BasePolicy from '@/policies/BasePolicy.js';

export default class GradebookPolicy extends BasePolicy {
    before() {}

    view(user, course) {
        if (user.is_admin) {
            return true;
        }

        if (!course.grading_scheme_id) {
            return false;
        }

        return (
            user.hasPermissionViaCourseTo(course, 'view a gradebook') ||
            user.hasGroupPermissionWithinCourse(course, 'view a gradebook')
        );
    }

    viewPreview(user, course) {
        if (user.is_admin) {
            return true;
        }

        return (
            user.hasPermissionViaCourseTo(course, 'view a gradebook preview') ||
            user.hasGroupPermissionWithinCourse(course, 'view a gradebook preview')
        );
    }

    viewTemplatePreview(user, courseTemplate) {
        if (user.is_admin) {
            return true;
        }

        return (
            user.hasGroupPermissionWithinCourseTemplate(courseTemplate, 'view a gradebook preview') &&
            courseTemplate.has_gradable_activity
        );
    }

    viewStudent(user, course) {
        return user.isStudentOf(course?.id) && course?.grading_scheme_id;
    }

    deleteCourseGrade(user) {
        return (
            user.hasPermissionTo('delete a course grade') || user.hasPermissionTo("delete another user's course grade")
        );
    }

    viewAllCourseGrade(user) {
        return user.hasPermissionTo('view all course grade');
    }
}
